import { createFileRoute } from '@tanstack/react-router';
import { Authenticated } from '../organisms/Authenticated';


export const Route = createFileRoute('/_authenticated')({
  component: () => (
    <main className="bg-background-primary h-full w-full flex overflow-hidden">
      <Authenticated />
    </main>
  ),
});
